module.exports = new __parcel__URL__("D2.a36061dd.mp3").toString();